import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

/**
 * The one flag guarding every in-app calculator surface — the standalone
 * routes (via `InAppCalculatorGate`) and the embedded practice window
 * (via the hook below). Exported so the two cannot drift apart.
 */
export const IN_APP_CALCULATOR_FLAG = 'in_app_calculator';

/**
 * Resolves the content-level "calculator allowed" designation for what the
 * student is currently practicing.
 *
 * STUB — the `calculator_allowed` guide-level designation does not exist yet
 * (#18233). Until it ships, content never withholds the calculator, so the
 * feature flag is the only thing gating it. When #18233 lands this reads the
 * field off the already-loaded guide levels: nearest explicit setting wins
 * (subtopic over topic over theme), most-restrictive wins across memberships.
 */
function resolveContentDesignation(): boolean {
  return true;
}

/**
 * One gate for every calculator surface: the toolbar button that opens the
 * window and the window itself both call this, so the entry point can never
 * offer something the window would refuse to show.
 *
 * A flag still loading counts as unavailable, so the button appears once and
 * stays rather than flickering in as the flag resolves.
 *
 * Adaptive practice has no assignment, so availability follows the content
 * designation alone. The teacher's per-assignment setting (#18234) joins this
 * when the assignment surface is wired up.
 */
export function useIsCalculatorAvailable(): boolean {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled(IN_APP_CALCULATOR_FLAG);

  if (!isFeatureEnabled || isLoading) {
    return false;
  }

  return resolveContentDesignation();
}
